import type React from 'react';
import { useWindowWidth } from '@shared/hooks';
import { useModuleByCodeParam } from '@shared/hooks/use-module-by-code-param.ts';
import { CommonImage } from 'library/components/common';
import Attribute from '../Attribute';
import * as st from './Product.module.scss';

type Props = {
  product: any;
};

const Product: React.FC<Props> = ({ product }) => {
  const windowWidth = useWindowWidth();

  const { permissions } = useModuleByCodeParam();

  const attributes = (product: any) => {
    const storage = [...product.storage];
    const id = product.storageitem;
    const currentProduct = storage.find((product) => product.id === id);
    return currentProduct?.attributevalue;
  };

  const quantity = {
    attribute: {
      title: 'Количество',
    },
    value: {
      title: product.count,
    },
  };

  const getPrice = (product: any) => {
    return (
      !permissions.can_sell
        ? (product.count * product.product?.current_price) / 100
        : (product.count * product.partner_price?.partner_amount) / 100
    ).toLocaleString();
  };

  return (
    <div className={st.root}>
      <CommonImage src={product.product.promo_image} style={st.image} />
      <div className={st.data}>
        <header className={st.data__title}>{product.product.title}</header>
        <div className={st.data__footer}>
          {windowWidth < 768 ? (
            <div className={st.data__attributes}>
              {attributes(product).map((attribute: any) => (
                <Attribute attribute={attribute} />
              ))}
              <div className={st.data__price}>
                {getPrice(product)}
                <span className={st.data__currency}> RUB</span>
              </div>
              <div className={st.data__count}>{product.count}</div>
            </div>
          ) : (
            <>
              <div className={st.data__attributes}>
                {attributes(product).map((attribute: any) => (
                  <Attribute attribute={attribute} />
                ))}
                <Attribute attribute={quantity} />
              </div>
              <div className={st.data__price}>
                {getPrice(product)}
                <span className={st.data__currency}> RUB</span>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Product;
